/* TestHelden · KI-Assistent-Widget (04.11.2026). Gehört zu snippets/th-assistent.liquid.
 *
 * - Sichtbar nur, wenn die Theme-Einstellung an ist ODER die Vorschau per ?assistent=1 (sessionStorage) läuft.
 * - Das iframe wird erst beim ersten Klick angelegt: vorher kein Request an app.testhelden.com (auch nicht beim
 *   Tippen oder Fokussieren der Suche).
 * - Einstiege: schwebender Knopf (icon) und „Berater“ in der Suche (suche-kopf, suche-mobil, suche-dropdown,
 *   suche-hero, suchseite). Der Suchtext geht als erste Nachricht mit (URL-Parameter frage beim ersten Laden,
 *   danach postMessage). Einstieg und Startfrage landen in der Messung der Plattform.
 * - postMessage nur mit exaktem Origin-Vergleich; aus dem iframe kommen nur Kennungen (variantId, Code, Gesprächs-ID).
 * - Warenkorb: /cart/add.js mit Zeilen-Eigenschaft _th_assistent=<Kennung>, Drawer über cart:update + open().
 * - Warenkorb-Attribut th_assistent=<Kennung> über window.thKorbSchreiben (geteilte Warteschlange, nur eigener Schlüssel).
 */
(function () {
  'use strict';
  var wurzel = document.getElementById('th-assistent');
  var fenster = document.querySelector('[data-th-as-fenster]');
  if (!wurzel || !fenster) return;
  var knopf = wurzel.querySelector('[data-th-as-knopf]');
  var laden = fenster.querySelector('[data-th-as-laden]');
  var APP = wurzel.getAttribute('data-app') || 'https://app.testhelden.com';
  var VORSCHAU_KEY = 'th_assistent_vorschau';
  var ATTRIBUT_KEY = 'th_assistent_attribut';
  var EINSTIEGE = ['icon', 'suche-kopf', 'suche-mobil', 'suche-dropdown', 'suche-hero', 'suchseite'];

  // Vorschau-Schalter: ?assistent=1 merkt sich die Sitzung, ?assistent=0 beendet sie.
  var vorschau = false;
  try {
    var p = new URLSearchParams(location.search).get('assistent');
    if (p === '1') { sessionStorage.setItem(VORSCHAU_KEY, '1'); vorschau = true; }
    else if (p === '0') { sessionStorage.removeItem(VORSCHAU_KEY); }
    else { vorschau = sessionStorage.getItem(VORSCHAU_KEY) === '1'; }
  } catch (e) {}
  var aktiv = wurzel.getAttribute('data-aktiv') === '1' || vorschau;
  if (!aktiv) return;
  wurzel.hidden = false;

  var seite = {
    typ: wurzel.getAttribute('data-typ') || 'sonstige',
    handle: wurzel.getAttribute('data-handle') || null,
    test: wurzel.getAttribute('data-test') || null
  };
  var titel = wurzel.getAttribute('data-titel') || '';
  var iframe = null;
  var offen = false;
  var bereit = false;
  var gespraech = { id: null, kurzId: null };
  var zuletztFokus = null;
  var wartendeFrage = null; // Frage, die ans iframe geht, sobald es „bereit“ meldet

  function einstiegOk(e) { return EINSTIEGE.indexOf(e) > -1 ? e : 'icon'; }

  function url(einstieg, frage) {
    var q = new URLSearchParams();
    q.set('typ', seite.typ);
    if (seite.handle) q.set('handle', seite.handle);
    if (seite.test) q.set('test', seite.test);
    q.set('host', location.origin);
    q.set('pfad', location.pathname + location.search);
    if (titel) q.set('titel', titel);
    q.set('einstieg', einstiegOk(einstieg));
    if (frage) q.set('frage', frage.slice(0, 300));
    return APP + '/assistent?' + q.toString();
  }

  function anIframe(daten) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(Object.assign({ quelle: 'th-assistent-widget' }, daten), APP);
  }

  function melden(art, daten) {
    try {
      fetch(APP + '/api/mobile/shop/assistent/ereignis', { method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ gespraechId: gespraech.id, art: art, daten: daten || {} }) }).catch(function () {});
    } catch (e) {}
  }

  function oeffnen(einstieg, frage) {
    einstieg = einstiegOk(einstieg);
    frage = (frage || '').replace(/\s+/g, ' ').trim();
    zuletztFokus = document.activeElement;
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.title = 'KI-Assistent von TestHelden';
      iframe.setAttribute('allow', '');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      iframe.src = url(einstieg, frage);
      iframe.addEventListener('load', function () { if (laden) laden.hidden = true; });
      fenster.appendChild(iframe);
      melden('widget_geoeffnet', { einstieg: einstieg });
    } else if (frage) {
      if (bereit) anIframe({ type: 'frage', text: frage, einstieg: einstieg });
      else wartendeFrage = { text: frage, einstieg: einstieg };
    }
    if (offen) { if (bereit) anIframe({ type: 'fokus' }); return; }
    offen = true;
    fenster.hidden = false;
    knopf.setAttribute('aria-expanded', 'true');
    wurzel.hidden = true;
    document.body.classList.add('th-as-offen');
    document.addEventListener('keydown', taste);
    if (bereit) anIframe({ type: 'fokus' });
    else setTimeout(function () { try { iframe.focus(); } catch (e) {} }, 300);
  }

  function schliessen() {
    if (!offen) return;
    offen = false;
    fenster.hidden = true;
    wurzel.hidden = false;
    knopf.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('th-as-offen');
    document.removeEventListener('keydown', taste);
    try { (zuletztFokus && zuletztFokus.focus ? zuletztFokus : knopf).focus(); } catch (e) {}
  }

  function taste(e) { if (e.key === 'Escape') schliessen(); }

  knopf.addEventListener('click', function () { oeffnen('icon', ''); });

  /* ── „Berater“ in der Suche: Knöpfe und Zeilen freischalten, Klick öffnet den Chat mit dem Suchtext ── */
  function suchtext(el) {
    var direkt = el.getAttribute('data-th-as-frage');
    if (direkt) return direkt;
    var form = el.closest('form');
    var feld = form ? form.querySelector('input[name="q"]') : null;
    if (feld && feld.value.trim()) return feld.value;
    // Vorschlagsliste: das aktive Suchfeld des Kopfs (Desktop-Feld oder Overlay-Feld)
    var felder = document.querySelectorAll('[data-th-search-input]');
    for (var i = 0; i < felder.length; i++) if (felder[i].value && felder[i].value.trim()) return felder[i].value;
    return '';
  }
  function sucheSchliessen() {
    var hdr = document.querySelector('[data-th-v2-hdr]');
    if (hdr && typeof hdr.__thV2SucheZu === 'function') { try { hdr.__thV2SucheZu(); } catch (e) {} }
  }
  var beraterElemente = document.querySelectorAll('[data-th-as-berater]');
  for (var b = 0; b < beraterElemente.length; b++) {
    (function (el) {
      el.hidden = false;
      var feld = el.closest('.th-nav__search-form, .th-nav-search__field');
      if (feld) feld.classList.add('th-as-mit-berater');
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        var einstieg = einstiegOk(el.getAttribute('data-th-as-berater'));
        var frage = suchtext(el);
        sucheSchliessen();
        oeffnen(einstieg, frage);
      });
    })(beraterElemente[b]);
  }

  /* ── Warenkorb-Attribut (Kaufmarkierung „beeinflusst") ── */
  function korbSchreiben(attribute) {
    if (window.thKorbSchreiben) { try { return Promise.resolve(window.thKorbSchreiben(attribute)); } catch (e) { return Promise.resolve(null); } }
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attribute })
    }).catch(function () { return null; });
  }
  function attributSetzen(kurzId) {
    if (!kurzId || !/^[A-Z2-9]{8}$/.test(kurzId)) return;
    try { if (sessionStorage.getItem(ATTRIBUT_KEY) === kurzId) return; } catch (e) {}
    var a = {}; a['th_assistent'] = kurzId; // nur der eigene Schlüssel; Shopify führt Attribute zusammen
    korbSchreiben(a).then(function () { try { sessionStorage.setItem(ATTRIBUT_KEY, kurzId); } catch (e) {} });
  }

  /* ── Warenkorb-Zeile aus der Produktkarte (Kaufmarkierung „direkt") ── */
  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }
  function drawerOeffnen() {
    var oeffne = function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') { drawer.returnFocusTo = knopf; drawer.open(); }
      else { location.href = '/cart'; }
    };
    if (!document.querySelector('cart-drawer-component')) { location.href = '/cart'; return; }
    if (window.customElements && customElements.get('cart-drawer-component')) oeffne();
    else if (window.customElements) customElements.whenDefined('cart-drawer-component').then(oeffne);
    else location.href = '/cart';
  }
  function inDenWarenkorb(variantId, kurzId) {
    var props = {};
    if (kurzId) props['_th_assistent'] = kurzId;
    var body = { items: [{ id: Number(variantId), quantity: 1, properties: props }] };
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || 'Warenkorb-Fehler'); return d; }); })
      .then(function (d) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: d, sourceId: 'th-assistent', data: { source: 'th-assistent', variantId: String(variantId), sections: d.sections } }
        }));
        schliessen();
        drawerOeffnen();
      })
      .catch(function () { location.href = '/cart/add?id=' + encodeURIComponent(variantId) + '&quantity=1&properties%5B_th_assistent%5D=' + encodeURIComponent(kurzId || ''); });
  }

  /* ── Nachrichten aus dem iframe: nur exakter Origin, nur Kennungen ── */
  window.addEventListener('message', function (e) {
    if (e.origin !== APP) return;
    var d = e.data;
    if (!d || d.quelle !== 'th-assistent') return;
    if (d.type === 'bereit') {
      bereit = true;
      anIframe({ type: 'kontext', seite: seite });
      if (wartendeFrage) { anIframe({ type: 'frage', text: wartendeFrage.text, einstieg: wartendeFrage.einstieg }); wartendeFrage = null; }
      return;
    }
    if (d.type === 'schliessen') { schliessen(); return; }
    if (d.type === 'gespraech') {
      gespraech.id = typeof d.gespraechId === 'string' ? d.gespraechId : null;
      gespraech.kurzId = typeof d.kurzId === 'string' ? d.kurzId : null;
      if (gespraech.kurzId) attributSetzen(gespraech.kurzId);
      return;
    }
    if (d.type === 'warenkorb') {
      var v = String(d.variantId || '');
      if (!/^[0-9]{1,20}$/.test(v)) return;
      var k = typeof d.kurzId === 'string' && /^[A-Z2-9]{8}$/.test(d.kurzId) ? d.kurzId : gespraech.kurzId;
      inDenWarenkorb(v, k);
    }
  });

  /* ── Gratis-Tests: laufende Testphase melden (nur Kennung, keine Inhalte) ── */
  document.addEventListener('thct:phase', function (e) {
    var det = (e && e.detail) || {};
    if (det.instrument) { seite.test = String(det.instrument); if (bereit) anIframe({ type: 'kontext', seite: seite }); }
  });

  window.thAssistent = { oeffnen: function (einstieg, frage) { oeffnen(einstieg || 'icon', frage || ''); }, schliessen: schliessen };
})();
